/**
 * If changing the page paths, remember to change the folder name in the app folder as well.
 */
export const PRODUCTS_PAGE_PATH = '/produkter';

export const SITE_NAME = 'Bjørnstad Bruk';
